<template>
    <div class="container">
        <vue-headful title="ABL Groupe | BÖLLINGHAUS" />
        <h2>BÖLLINGHAUS</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../assets/images/header.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Aciers inoxydables laminé à chauds</h3>
                        <div>
                            <p>Plats : largeur 15 à 130 mm / épaisseur 4 à 50 mm</p>
                        </div>
                        <div>
                            <p>Carrés : 10 à 70 mm</p>
                        </div>
                        <div>
                            <p>Hexagones : 22 à 70 mm</p>
                        </div>
                        <div>
                            <p>Autres dimensions sur demande</p>
                        </div>
                        <h3>Hot rolled stainless steel profiles</h3>
                        <div>
                            <p>Flats : width 15 to 130 mm / thickness 4 to 50 mm</p>
                        </div>
                        <div>
                            <p>Squares : 10 to 70 mm</p>
                        </div>
                        <div>
                            <p>Hexagons : 22 to 70 mm</p>
                        </div>
                        <div>
                            <p>Other sizes upon request</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="society--content">
                <div class="society--process--description col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Aciers inoxydables étirés à froids</h3>
                        <div>
                            <p>Plats : largeur 15 à 100 mm / épaisseur 4 à 50 mm</p>
                        </div>
                        <div>
                            <p>Carrés : 22 à 65 mm</p>
                        </div>
                        <div>
                            <p>Hexagones : 22 à 65 mm</p>
                        </div>
                        <div>
                            <p>Autres dimensions sur demande</p>
                        </div>
                        <h3>Cold drawn stainless steel profiles</h3>
                        <div>
                            <p>Flats : width 15 to 100 mm / thickness 4 to 50 mm</p>
                        </div>
                        <div>
                            <p>Squares : 22 to 65 mm</p>
                        </div>
                        <div>
                            <p>Hexagons : 22 to 65 mm</p>
                        </div>
                        <div>
                            <p>Other sizes upon request</p>
                        </div>
                    </div>
                </div>
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../assets/images/Platacierinox_2.jpg')"/></div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "BollinghausColddrawn"
    }
</script>

<style scoped>

</style>